const yup = require("yup");
module.exports = yup
  .string()
  .oneOf(["on"], "Please agree to continue")
  .required("Please agree to continue");
